module.exports = __webpack_public_path__ + "static/media/drawer-calcal.01f03a21.png";